import { Link } from "react-router-dom";
import vision from "../../assets/images/webp/about-2-consult.webp";
import vision2 from "../../assets/images/webp/about-3-consult.webp";
import author from "../../assets/images/webp/testimonials-avatar-7.webp";
import ImageCards from "../common/components/about/ImageCards";
import Hero from "../common/components/Hero";
import Icons from "../common/components/Icons";
import BlueTag from "../common/ui/BlueTag";
import Cta from "../common/ui/Cta";
import Heading from "../common/ui/Heading";
import Paragraph from "../common/ui/Paragraph";

const Vision = () => {
  const visionList = {
    title: "Shaping a Future of Limitless Possibilities",
    description: [
      "We envision a future where businesses thrive by embracing innovation, leveraging emerging technologies, and shaping a world of limitless possibilities.",
      "Through our strategic solutions, we aim to be the trusted partner for businesses looking to grow, adapt, and succeed in an ever-evolving global market.",
    ],

    infoHeading:
      "Our goal is to be a catalyst for transformation, fostering a sustainable future for industries worldwide.",
    cta: false,
    author: {
      name: "Deepak Sharma",
      role: "Founder & CEO",
      img: author,
    },
    second: {
      title: "",
      description: [
        "Our vision is to create a lasting positive impact on over 12,000 clients globally, empowering them to reach their full potential.",
      ],
      img1: vision,
      img2: vision2,
    },
  };

  return (
    <div className="pb-48">
      <Hero value={6} />
      {visionList && (
        <div className="bg-white pt-10 sm:pt-14 md:pt-20 lg:pt-24 pb-14 sm:pb-16 md:pb-24 lg:pb-28 xl:pb-[140px]">
          <div className="container  mx-auto max-lg:px-3.5 max-md:px-6">
            <div className="flex max-xl:flex-col gap-y-8  gap-x-[57px]">
              <div className="max-lg:max-w-[714px] xl:max-w-[500px] 2xl:max-w-[700px] w-full mx-auto 2xl:ml-0">
                <BlueTag>About us</BlueTag>

                <Heading
                  className={`pt-1 max-xl:mx-auto xl:max-w-[456px]  2xl:max-w-[600px] `}
                >
                  {visionList.title}
                </Heading>
                {visionList.description.map((detail, index) => (
                  <Paragraph
                    key={index}
                    className="pt-3 max-w-[778px] xl:max-w-[500px]  2xl:max-w-[600px]"
                  >
                    {detail}
                  </Paragraph>
                ))}

                {visionList.listBadges && (
                  <div className="inline-flex flex-col gap-y-4 pt-5">
                    {visionList.listBadges.map((obj, index) => (
                      <div
                        key={index}
                        className="inline-flex items-center  gap-x-1.5"
                      >
                        <Icons
                          className="min-w-[18px]"
                          icon="blue-check-mark"
                        />
                        <p className="font-semibold text-sm !leading-130 text-custom-dark-blue">
                          {obj}
                        </p>
                      </div>
                    ))}
                  </div>
                )}
                {visionList.infoHeading && (
                  <h3 className="font-bold !leading-150 text-base md:text-lg text-custom-dark-blue sm:max-w-[768px] xl:max-w-[421px] pt-4 md:pt-6  2xl:max-w-[600px]">
                    {visionList.infoHeading}
                  </h3>
                )}
                {visionList.cta && (
                  <Cta className="max-sm:w-full mt-4 sm:mt-6 md:mt-8">
                    <Link to="/contact-us">Get A Quote</Link>
                  </Cta>
                )}
                {visionList.author && (
                  <div className="flex items-center gap-x-3 mt-3 md:mt-5">
                    <img
                      src={visionList.author.img}
                      alt="author"
                      className="size-11 object-cover rounded-full overflow-clip"
                    />
                    <div>
                      <h3 className=" text-custom-dark-blue text-sm font-semibold !leading-133">
                        {visionList.author.name}
                      </h3>
                      <p className="text-xs !leading-155 font-normal pt-1 text-custom-dark-blue">
                        {visionList.author.role}
                      </p>
                    </div>
                  </div>
                )}
              </div>
              <div className={` flex grow xl:max-w-[583px] 2xl:max-w-[42%] `}>
                <ImageCards detail={visionList.second} />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Vision;
